import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './sic-contact-block.css.lit';
import defaultVars from './css-variables/sic-contact-block-vars.css.lit';

/** all fields optional
 * @slot title
 * @slot contact (phone and fax)
 * @slot CTA
 * @slot description (WYSIWYG)
 */

@customElement('sic-contact-block')
export class SicContactBlock extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, defaultVars];
  slots = new SlotsController(this);

  render(): TemplateResult {
    return html`
      <div class="container">
        <div class="content">
          <sic-heading level-size="1">
            ${this.slots.conditionalSlot('title')}
          </sic-heading>
          ${this.slots.conditionalSlot('contact', false)}
          <div class="cta-wrapper">
            ${this.slots.conditionalSlot('cta', false)}
          </div>
        </div>
        <div>${this.slots.conditionalSlot('description', false)}</div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-contact-block': SicContactBlock;
  }
}
